module.exports = "/img/vendor/swipebox/src/icons.png?a4a2b70f7689e4efdf33ed523ffae512";


//////////////////
// WEBPACK FOOTER
// ./node_modules/swipebox/src/img/icons.png
// module id = FJT9
// module chunks = 0